/**
 * Extracts the width and height from a string url
 * with a predefined format.
 * Example:
 * input - url: https://stage.cdn1.parksmedia.wdprapps.disney.com/resize/mwImage/1/170/96/75/dam/wdpro-assets/dino-sue/dino-sue-00.jpg
 * return - {
 *    width: '170',
 *    height: '96',
 * }
 *
 * @param url the image url from where to extract the sizes.
 * @returns an object with a width and height property, if it cannot extract the size
 * from the url will return default sizes width = 100% height = 100%
 */
const getImageSize = (url: string) => {
    const defaultSizes = {
        width: '100%',
        height: '100%',
    };

    if (!url) {
        return defaultSizes;
    }

    const regex = /\/mwImage\/\d+\/(?<width>\d+)\/(?<height>\d+)\/\d+\//;
    const match: RegExpMatchArray | null = url.match(regex);

    if (!match) {
        return defaultSizes;
    }

    return {
        width: match.groups?.width,
        height: match.groups?.height
    };
};

export default getImageSize;

